import React from "react";
import InfiniteScrollList from "../../../commonComponents/util/InfiniteScrollList";
import ReceivingParticipantsTableRow from './ReceivingParticipantsTableRow';

export default class ReceivingParticipantsTable extends React.Component {
  
  getReceivingParticipants = async (page, sort, reset = false) =>
  this.props.getReceivingParticipants(reset, page, this.props.results, sort);

  getTableRow = (participant) => {
    return <ReceivingParticipantsTableRow
              key={participant.externalListMemberId}
              participant={participant} 
              rejectedParticipants={this.props.rejectedParticipants}
              updateRejectedParticipants={(this.props.updateRejectedParticipants)}/>;
  }

  render() {
    const { 
        data: { records, totalCount },
        hasMore,
        loading,
        page,
        results,
        sort,
        success
      } = this.props;
      
    return (
        <InfiniteScrollList
          name="receiving participants"
          page={page}
          totalCount={totalCount}
          resultsView={results}
          sort={sort}
          loading={loading}
          success={success}
          renderRecord={this.getTableRow}
          columns={[
              { title: "Reject", id: null },
              { title: "Name", sortable: true, id: "name" },
              {
                title: "Position",
                sortable: true,
                id: "position"
              },
              {
                title: "Rejected Reason",
                sortable: false,
                id: "reason"
              }
          ]}
          records={records || []}
          hasMore={hasMore}
          showFooter={false}
          getRecords={this.getReceivingParticipants}
          hideScrollToTopButton={true}
        />
      );
  }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignDetails/VerifyCampaignListWizard/ReceivingParticipantsTable.jsx